import React from 'react';

import { NavButton } from '@pkg/components/Navigation/SidebarNav/NavButton';
import { Buttons } from '@pkg/components/Navigation/SidebarNav/styles';

import config from '@app/config';
import { AUTH_SIGN_IN } from '@app/routes/paths/auth';

import { PodsSection } from '../PodsSection';
import { YatFantasySection } from '../YatFantasySection';

const { privacyLink, supportLink, termsLink } = config;

export const LoggedOutSection = () => {
    return (
        <>
            <Buttons>
                <NavButton to={AUTH_SIGN_IN}>
                    Sign up <span>or</span> Log in
                </NavButton>

                <NavButton to="/create">Create Yats</NavButton>

                <NavButton to={supportLink} newTab>
                    Help Center
                </NavButton>

                <NavButton to={termsLink} newTab>
                    Terms of Service
                </NavButton>

                <NavButton to={privacyLink} newTab>
                    Privacy Policy
                </NavButton>
            </Buttons>

            <YatFantasySection isStatic={true} isOpen={true} />

            <PodsSection isStatic={true} isOpen={true} isAuthenticated={false} />
        </>
    );
};
